export default "__VITE_ASSET__h02iufiL__"